export default "__VITE_ASSET__DVXWauEz__"